import { FC } from 'react';
import { CustomChangeEvent, Text } from '@frontend/design-system';
import { Category } from '../../../../../../types/form-template.types';
import { errorMessageStyle, fieldLabelTextStyle } from '../checklist-field/checklist-field.styles';
import { CategorizedChecklist } from './categorized-checklist';

export interface CategorizedChecklistFieldProps {
  id: string;
  name: string;
  label: string;
  'aria-invalid': boolean;
  touched: boolean;
  error?: string;
  onBlur: () => void;
  onChange: (e: CustomChangeEvent<string[]>) => void;
  value: string[];
  categories: Category[];
}

export const CategorizedChecklistField: FC<CategorizedChecklistFieldProps> = ({
  id,
  name,
  label,
  'aria-invalid': ariaInvalid,
  touched: _touched,
  error,
  onBlur,
  onChange,
  value,
  categories,
}) => {
  const hasError = ariaInvalid;

  const handleChange = (newValue: string[]) => {
    onChange({ name, value: newValue });
  };

  return (
    <>
      {label && (
        <Text weight='regular' css={fieldLabelTextStyle}>
          {label}
        </Text>
      )}
      {categories.map((category) => (
        <CategorizedChecklist
          key={category.id}
          category={category}
          fieldId={id}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          hasError={hasError}
        />
      ))}
      {hasError && error && (
        <Text size='small' css={errorMessageStyle}>
          {error}
        </Text>
      )}
    </>
  );
};
